import { cn } from '@/platform/lib/utils';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/20/solid';

const FilterBarSearch = ({
    value = '',
    onChange,
    placeholder = 'Zoeken...',
    className,
    ...props
}) => (
    <div
        className={cn('relative flex min-w-48 flex-1 items-center', className)}
    >
        {value.length > 0 ? (
            <button
                type='button'
                onClick={() => onChange?.('')}
                aria-label='Wissen'
                className='absolute left-4 inline-flex cursor-pointer items-center justify-center text-gray-400 transition hover:text-gray-600'
            >
                <XMarkIcon className='size-5' />
            </button>
        ) : (
            <MagnifyingGlassIcon className='text-primary-500 pointer-events-none absolute left-4 size-5' />
        )}
        <input
            type='text'
            value={value}
            onChange={event => onChange?.(event.target.value)}
            placeholder={placeholder}
            className='h-12 w-full border-0 bg-transparent pr-4 pl-11 text-sm shadow-none outline-none placeholder:text-gray-400 focus:border-0 focus:ring-0'
            {...props}
        />
    </div>
);

export default FilterBarSearch;
